import Reflux from 'reflux';

const rgba = (input, opacity = 1) => {
  const hex = input.replace('#', '');
  const r = Math.ceil(parseInt(hex.substring(0, 2), 16));
  const g = Math.ceil(parseInt(hex.substring(2, 4), 16));
  const b = Math.ceil(parseInt(hex.substring(4, 6), 16));
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

var ThemeStore = Reflux.createStore({
  data: {
    creen: { r: 0, g: 201, b: 204 },
    green: { r: 39, g: 174, b: 96 },
    blue: { r: 52, g: 152, b: 219 },
    blue2: { r: 41, g: 128, b: 185 },
    purple: { r: 155, g: 89, b: 182 },
    navyblue: { r: 52, g: 73, b: 94 },
    gray: { r: 127, g: 140, b: 141 },
    red: { r: 192, g: 57, b: 43 },
    lightgreen: { r: 102, g: 215, b: 119 },
    teal: { r: 1, g: 150, b: 149 },
    mustard: { r: 146, g: 144, b: 25 },
    darkblue: { r: 16, g: 84, b: 147 },
    golden: { r: 209, g: 206, b: 98 },
    mango: { r: 249, g: 195, b: 50 },
    pinktaco: { r: 238, g: 124, b: 182 },
    pinkster: { r: 241, g: 141, b: 139 },
    orange: { r: 243, g: 147, b: 49 },
    love: { r: 168, g: 51, b: 81 },
    purplehaze: { r: 128, g: 44, b: 106 },
    raspberry: { r: 237, g: 76, b: 124 }
  },
  getInitialState() {
    return this.data;
  },
  getColor(theme = 'creen', alpha = 1) {
    if (!this.data[theme || 'creen']) {
      return rgba(theme || 'creen', alpha);
    } else {

    }
    var color = this.data[theme || 'creen'];
    return (
      'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + alpha + ')'
    );
  },
  getAllThemes() {
    return this.data;
  }
});

export default ThemeStore;



// WEBPACK FOOTER //
// ./src/js/stores/Theme.js